const FeatureShowcaseCard = () => {
  const videos = document.querySelectorAll(".a-feature-showcase-card .a-feature-showcase-card__video");

  const observerOptions = {
    root: null,
    rootMargin: "0px",
    threshold: [0, 0.3]  // Trigger events when 0% or 30% of the element is visible
  };

  const videoObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      const video = entry.target;

      // Check if the video is at least 30% in view
      if (entry.intersectionRatio >= 0.3 && !video.ended) {
        video.play();
      }
    });
  }, observerOptions);

  const watchVideos = () => {
    videos.forEach(video => {
      videoObserver.observe(video);
    });
  }
  window.addEventListener("DOMContentLoaded", watchVideos);
}

export default FeatureShowcaseCard;
